import { Component, OnInit } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {LoginService} from '../login.service';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.css']
})
export class DeleteComponent implements ICellRendererAngularComp {
  public params: any;
  public serverConst:any;
  constructor(public loginService:LoginService) { }
  
      agInit(params: any): void {
          this.params = params;
      }
  
      refresh(): boolean {
          return false;
      }
      view(){
        window.open(this.loginService.serverConst+"/getFile/"+this.params.data.path,"_blank");
      }
}



// WEBPACK FOOTER //
// ./src/app/delete/delete.component.ts